import React from 'react';
import { motion } from 'framer-motion';

const Authority = () => {
  return (
    <section id="about" className="py-24 bg-navy-800 border-y border-white/5">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 grid md:grid-cols-12 gap-12 items-center">
        
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="md:col-span-5"
        >
          <div className="glass-card rounded-2xl overflow-hidden relative shadow-2xl p-2">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/e282dbabe0fb99c7297b43a6b0de1fd59d6d09f131d6f056b8f4fae024a0b5b57073e35ffb9eb9c92377fe5c622733be/images/aW1hZ2UvanBlZw==/9fc7c8d6cf54c49fe195687ad0ad3240.jpg" 
              alt="Chris Morris" 
              className="w-full h-auto rounded-xl grayscale hover:grayscale-0 transition-all duration-500"
            />
            <div className="absolute bottom-6 left-6 right-6 glass-card rounded-lg p-4 text-center">
              <span className="block font-bold text-white text-lg">Chris Morris</span>
              <span className="block text-teal text-sm font-semibold">Local Business Trust Strategist</span>
            </div>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="md:col-span-7 space-y-6"
        >
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
            I help brands build Trust Architecture.
          </h2>
          
          <div className="text-lg text-slate-300 space-y-5 leading-relaxed">
            <p>
              I help local businesses become more visible, trusted, and recommended online by fixing the authority, content, and credibility gaps that search engines and AI systems use to decide who deserves attention.
            </p>
            <p>
              <strong className="text-white">Most local businesses don’t have a traffic problem. They have a trust problem.</strong>
            </p>
            <p>
              I help fix the online signals that make Google, AI tools, and real customers understand why they should choose you over the competition.
            </p>
          </div>

          <div className="pt-6">
            <a href="#book" className="inline-block bg-white/10 hover:bg-white/20 text-white border border-white/20 px-8 py-4 rounded-lg font-bold transition-all">
              Book Your Audit
            </a>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Authority;